export interface ErrorResponse {
    title: string;
    message: string;
    severity: 'error' | 'warning' | 'info' | 'success';
}

export const errorHandling = (error: any): ErrorResponse => {
    if (error.response?.data?.error) {
        return {
            title: error.response.data.error,
            message: error.response.data.message,
            severity: 'error',
        }
    }
    return {
        title: error.message,
        message: error.options?.cause || '',
        severity: 'error',
    }

}

// need to add DSP ID validation if it is number, than erase this function and implement errorHandling function
export const errorBuyerSeatHandling = (error: any): ErrorResponse => {
    if (error.response?.data?.error) {
        if (error.response.data.error === 'Malformed JSON Request')
            return {
                title: "DSP ID needs to be a number",
                message: "DSP ID needs to be a number.",
                severity: 'error',
            }
        return {
            title: error.response.data.error,
            message: error.response.data.message,
            severity: 'error',
        }
    }
    return {
        title: error.message,
        message: error.options?.cause || '',
        severity: 'error',
    }

}
